// O Module Federation exige que o bootstrap seja assíncrono tanto no host quanto nos remotes.
// Sem este dynamic import, o React é carregado de forma eager antes do runtime do
// Module Federation negociar as dependências compartilhadas, causando o erro:
// "Shared module is not available for eager consumption"
import("./bootstrap");

export {};
